module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "calendar d-flex flex-column h-100 position-relative"
  }, [_c('div', {
    staticStyle: {
      "height": "65px"
    }
  }, [_c('navigator', {
    attrs: {
      "fullCalendar": _vm.fullCalendar
    },
    on: {
      "updateArrowDate": _vm.calculateSunTimes
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "calendar-content-p d-flex flexGrow1 position-relative"
  }, [_c('div', {
    staticClass: "flexGrow1"
  }, [_c('div', {
    staticClass: "calendar-wrapper"
  }, [_c('div', {
    ref: "calendarWidth",
    attrs: {
      "id": "calendar"
    },
    on: {
      "mousemove": _vm.positionCursorX
    }
  })])]), _vm._v(" "), _c('events', {
    on: {
      "changeFilters": _vm.filtersChanged
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "min-height": "1rem"
    }
  })])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-8e6efd2e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8e6efd2e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/Calendar.vue
// module id = 2691
// module chunks = 0